import { MajorFeatureByKeyQuery } from '~/config/generated/graphql';

export const handleMajorFeatureModal = ({
  vehicleMajorFeatureModal
}: MajorFeatureByKeyQuery) => {
  return {
    ...vehicleMajorFeatureModal
  };
};
